//@ts-check
import React from 'react';
import utils from '../../../utils';
import DataModelEditor from './DataModelEditor';
import DashboardEditor from './DashboardEditor';
import CsvEditor from './CsvEditor';
import FileEditorFrame from './FileEditorFrame';
/**
 * @param {import('./types').FileEditorProps} props
 */

var FileEditor = function FileEditor(props) {
  var path = props.path,
      onClose = props.onClose;
  var extension = utils.path.getFileExtension(path);
  var EditorComponent = null;

  switch (extension) {
    case 'edm':
    case 'edx':
      EditorComponent = DataModelEditor;
      break;

    case 'bid':
      EditorComponent = DashboardEditor;
      break;

    case 'csv':
      EditorComponent = CsvEditor;
      break;

    default:
      EditorComponent = FileEditorFrame;
      break;
  }

  return React.createElement(EditorComponent, props);
};

export default FileEditor;